import React, { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { formattedDate, getBookingStatus } from "../../helpers/Helper";
import xrayBookingsServices from "../../services/xrayBookings.services";
import { BASE_URL } from "../../services/config";

const BookingDetail = () => {
    let { id } = useParams();
    const navigate = useNavigate();

    const [bookingDetail, setBookingDetail] = useState('');
    const [loading, setLoading] = useState(true);

    const getBookingDetails = async (id) => {
        try {
            setLoading(true);
            const result = await xrayBookingsServices.bookingDetailApi(id)
            if (result.status === 200) {
                console.log('result', result.data.booking_details)
                setBookingDetail(result.data.booking_details)
            }
        } catch (error) {
            console.error('Error fetching booking details:', error);
        } finally {
            setLoading(false);
        }
    }

    const downloadEmployeeData = () => {
        fetch('http://103.15.67.180:4000/data/uploads/1683729551533-scaled_18074f50-19e2-4b7d-9802-2b08ee25b1707199747260387734619.jpg')
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = 'employees.jpg';
                    a.click();
                });
                //window.location.href = response.url;
            });
    }
    useEffect(() => {
        getBookingDetails(id)
    }, [])

    if (loading) {
        return (
            <div className="page-wrapper">
                <div className="page-content-wrapper">
                    <div className="page-content">
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                            <div className="text-center">
                                <div className="spinner-border text-primary mb-2" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <h6 className="text-muted mb-0">Loading booking details...</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {/*page-wrapper*/}
            <div className="page-wrapper">
                {/*page-content-wrapper*/}
                <div className="page-content-wrapper">
                    <div className="page-content">
                        <>
                            {/*breadcrumb*/}
                            <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                                {/* <div className="breadcrumb-title pe-3">Center</div> */}
                                <div className="ps-3">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb mb-0 p-0">
                                            <li className="breadcrumb-item">
                                                <a href="#">
                                                    {/* <i className="bx bx-home-alt" /> */}
                                                </a>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">
                                                Booking Details
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                                <div className="ms-auto">
                                    <div className="btn-group">
                                        <button className="btn btn-primary"
                                            onClick={() => {
                                                // navigate(`/user/bookings/${id}`)
                                                navigate(`/user/bookings/${bookingDetail.user_id}`)
                                            }}><i className="bx bx plus" />Return To List</button>

                                    </div>
                                </div>
                            </div>
                            {/*end breadcrumb*/}


                            <Row>
                                <Col>
                                    <div className="card">
                                        <div class="card-header">
                                            <div class="card-title">
                                                {/* <h6 class="mb-0 pt-2 brand-color">Patent Info ({`Booking Id: ${bookingDetail.xray_booking_id}`}) */}
                                                <h6 class="mb-0 pt-2 brand-color">Patient Info

                                                </h6>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <Table responsive striped bordered hover>
                                                <tbody>
                                                    <tr>
                                                        <td className='fw-bold'>Patient Name </td>
                                                        <td className=''>{bookingDetail.patent_name} </td>

                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Gender </td>
                                                        <td className=''>{bookingDetail.patent_gender} </td>

                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Age </td>
                                                        <td className=''>{bookingDetail.patent_age} </td>

                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'> Location Type</td>
                                                        <td className=''>{bookingDetail?.user_location?.location_type} </td>

                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Address </td>
                                                        <td className=''>{bookingDetail?.user_location?.address} </td>

                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Patient Remark</td>
                                                        <td className=''>{bookingDetail?.user_remark} </td>

                                                    </tr>

                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>

                                </Col>
                                <Col>
                                    <div className="card">
                                        <div class="card-header">
                                            <div class="card-title">
                                                <h6 class="mb-0 pt-2 brand-color">Booking Info
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <Table responsive striped bordered hover>
                                                <tbody>
                                                    <tr>
                                                        <td className='fw-bold'>Booking Id </td>
                                                        <td className=''>{bookingDetail.xray_booking_id} </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>X-ray Type </td>
                                                        <td className=''>{bookingDetail.xray_type_name} </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Booking Date </td>
                                                        <td className=''>{formattedDate(bookingDetail.booking_date)} </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Appointment Date </td>
                                                        <td className=''>{formattedDate(bookingDetail.appointment_date)} </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Appointment Slot </td>
                                                        <td className=''>{bookingDetail.appointment_slot} </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Booking Status </td>
                                                        <td className=''>{getBookingStatus(bookingDetail.booking_status_id)} </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="card">
                                        <div class="card-header">
                                            <div class="card-title">
                                                <h6 class="mb-0 pt-2 brand-color">X-ray Center Info
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <Table responsive striped bordered hover>
                                                <tbody>
                                                    <tr>
                                                        <td className='fw-bold'>Center Name </td>
                                                        <td className=''>{bookingDetail?.center_name} </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Center Contact No. </td>
                                                        <td className=''>{bookingDetail.center_contact_no} </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Center E-mail </td>
                                                        <td className=''>{bookingDetail.center_email} </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Center Address </td>
                                                        <td className=''>{bookingDetail.center_address} </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Operator Name </td>
                                                        <td className=''>{bookingDetail.operator_name} </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Operator Contact No. </td>
                                                        <td className=''>{bookingDetail.operator_contact} </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Col>

                                {/* {bookingDetail?.booking_status_id===6&&  */}


                            </Row>
                            <Row>
                                <Col>
                                    <div className="card">
                                        <div class="card-header">
                                            <div class="card-title">
                                                <h6 class="mb-0 pt-2 brand-color">X-ray Reports & Radiologist Prescription

                                                </h6>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <Table responsive striped bordered hover>
                                                <tbody>
                                                    <tr>
                                                        <td className='fw-bold'>X-ray Report </td>
                                                        <td className=''>
                                                            {bookingDetail?.xray_report_file ? <>
                                                                <a href={`${BASE_URL}/${bookingDetail.xray_report_file}`} target="_blank" rel="noopener noreferrer"><button className="btn btn-outline-primary btn-sm me-2">View</button></a>
                                                                {/* <a href={`${BASE_URL}/${bookingDetail.xray_report_file}`} target="_blank" rel="noopener noreferrer" ><button className="btn btn-primary btn-sm" onClick={(e)=>download(`${BASE_URL}/${bookingDetail.xray_report_file}`,'test')}>Download</button></a> */}
                                                                {/* <button className="btn btn-primary btn-sm" onClick={downloadEmployeeData}>Download</button> */}
                                                            </> : 'Pending'}
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Radiologist Prescription Report </td>
                                                        <td className=''>
                                                            {bookingDetail?.dr_prescription_file ? <>
                                                                <a href={`${BASE_URL}/${bookingDetail.dr_prescription_file}`} target="_blank" rel="noopener noreferrer"><button className="btn btn-outline-primary btn-sm me-2">View</button></a>
                                                                {/* <a href={`${BASE_URL}/${bookingDetail.dr_prescription_file}`} target="_blank" rel="noopener noreferrer" ><button className="btn btn-primary btn-sm" >Download</button></a> */}
                                                            </> : 'Pending'}
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className='fw-bold'>Radiologist Prescription Remark </td>
                                                        <td className=''>{bookingDetail.dr_prescription_remark} </td>

                                                    </tr>
                                                    {/* <tr>
                                                    <td className='fw-bold'>Address </td>
                                                    <td  className=''>{bookingDetail?.user_location?.address} </td>

                                            </tr> */}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>

                                </Col>
                            </Row>
                        </>

                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default BookingDetail;